module.exports = __webpack_public_path__ + "img/mssymbol.319d9b9a.svg";